import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  Input,
  InputGroup,
  InputRightElement,
  InputLeftElement,
  IconButton
} from '@chakra-ui/react'
import { useDebounce } from '../../hooks'

const SearchBar = ({ onSearch, debounce, value, ...otherProps }) => {
  const [searchTerm, setSearchTerm] = useState(value || null)
  const debouncedSearchTerm = useDebounce(searchTerm, debounce)

  useEffect(() => {
    onSearch(
      debouncedSearchTerm && debouncedSearchTerm.trim().length
        ? debouncedSearchTerm.trim()
        : null
    )
  }, [debouncedSearchTerm, onSearch])

  return (
    <InputGroup size={otherProps?.size}>
      <InputLeftElement pointerEvents="none" color="gray.500" fontSize="1.2rem">
        <i className={`fas fa-search`} />
      </InputLeftElement>
      <Input
        value={searchTerm || ''}
        onChange={(e) => setSearchTerm(e.target.value)}
        {...otherProps}
      />
      <InputRightElement>
        <IconButton
          size="xs"
          borderRadius="sm"
          borderWidth="1px"
          borderColor="gray.300"
          onClick={() => {
            if (searchTerm) {
              setSearchTerm(null)
              onSearch(null)
            }
          }}
          icon={<i className="fas fa-times" />}
        />
      </InputRightElement>
    </InputGroup>
  )
}

SearchBar.propTypes = {
  onSearch: PropTypes.func,
  debounce: PropTypes.number,
  value: PropTypes.string
}

SearchBar.defaultProps = {
  onSearch: () => {},
  debounce: 750,
  value: undefined
}

export default SearchBar
